import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  TemplateRef,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { LinkItem } from '../link-item';
import { NavigationFooterComponent } from './navigation-footer.component';
import { NavigationHeaderComponent } from './navigation-header.component';

@Component({
  selector: 'core-nav-shell',
  imports: [RouterModule, NavigationHeaderComponent, NavigationFooterComponent],
  template: `
    <div
      class="text-primary grid h-full w-full grid-rows-[auto_1fr_auto] bg-black font-normal"
    >
      <core-nav-header
        [leadingActionsTemplate]="leadingActionsTemplate()"
        [trailingActionsTemplate]="trailingActionsTemplate()"
        (login)="onLogin()"
        (logout)="onLogout()"
        (switchCustomer)="onSwitchCustomer()"
      />
      <div class="bg-1 p-16 pt-8 w-full max-content-width mx-auto">
        <router-outlet></router-outlet>
      </div>
      <core-nav-footer [links]="links()" />
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationShellComponent {
  public links = input<LinkItem[]>([]);

  public readonly leadingActionsTemplate = input<TemplateRef<unknown> | null>(
    null,
  );

  public readonly trailingActionsTemplate = input<TemplateRef<unknown> | null>(
    null,
  );

  public login = output<void>();

  public logout = output<void>();

  public switchCustomer = output<void>();

  protected onLogin() {
    this.login.emit();
  }

  protected onLogout() {
    this.logout.emit();
  }

  protected onSwitchCustomer() {
    this.switchCustomer.emit();
  }
}
